import { PayloadAction } from '@reduxjs/toolkit'
import { GetInvoiceParams } from './danfeTypes'
import { getDanfe } from './danfeApi'
import { actions } from './danfeState'
import {
  all, call, put, takeLatest,
} from 'redux-saga/effects'
import { toast } from 'react-toastify'
import { ReturnCall } from 'src/features/types'

export function* getInvoice(params: PayloadAction<GetInvoiceParams>) {
  yield put(actions.setLoading(true))
  yield put(actions.setInvoiceHtml(''))

  try {
    const danfe: ReturnCall<typeof getDanfe> = yield call(getDanfe, params.payload)

    if (!danfe.isOk) {
      toast.error('Falha ao encontrar NFe')
      return
    }

    yield put(actions.setInvoiceHtml(danfe.data))
  } catch (error: any) {
    toast.error(`Ocorreu um erro: ${error?.response?.data?.message ?? error.message}`)
  } finally {
    yield put(actions.setLoading(false))
  }
}

export default function* () {
  yield all([takeLatest(actions.getInvoice.type, getInvoice)])
}
